import {useRouter} from 'next/dist/client/router';
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useFullVariantByIdSsr} from '../../../api/hooks/useFullVariantByIdSsr.hook';
import {useInstanceDetailPage} from '../../../api/hooks/useInstanceDetail.hook';
import {fetchMoreInstances} from '../../../redux';
import {BasicCardVariants} from '../../../utils/_enums/basic-card-variants.enum';
import {FilterExpression} from '../../../utils/_enums/filter-expression.enum';
import {useAppSelector} from '../../../utils/_hooks/hooks';
import Teaser from '../../_shared/teaser/teaser';
import TeaserCard from '../../_shared/teaser-card/teaser-card';

const MoreInstancesBox = (): JSX.Element => {
    const dispatch = useDispatch();
    const router = useRouter();
    const data = useInstanceDetailPage();
    const variant = useFullVariantByIdSsr();
    const {instances, addToBasketStatus, addToBasketPending} = useAppSelector(
        (state) => ({
            instances: state.productSlice.moreInstances,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus,
            addToBasketPending: state.checkoutSlice.pending
        })
    );

    useEffect(() => {
        fetchInstancesWithFilter(0, 6);
    }, [variant, router.query.instanceId]);

    const fetchInstancesWithFilter = (offset: number, pageSize: number) => {
        if (variant?.id) {
            dispatch(fetchMoreInstances([
                {
                    value: pageSize.toString(),
                    param: 'size',
                    comparisonType: FilterExpression.none
                },
                {
                    value: offset.toString(),
                    param: 'offset',
                    comparisonType: FilterExpression.none
                },
                {
                    value: variant.id.toString(),
                    param: 'variantId',
                    comparisonType: FilterExpression.equals
                },
                {
                    value: 'OPEN',
                    param: 'status',
                    comparisonType: FilterExpression.equals
                },
                {
                    value: router.query.instanceId as string,
                    param: 'id',
                    comparisonType: FilterExpression.notEquals
                },
                {
                    param: 'sort',
                    comparisonType: FilterExpression.none,
                    value: 'serialNumber,asc'
                }
            ]));
        }

    }

    return (
        <div>
            <Teaser
                headline={data.moreInstancesListHeadline.headlineContent}
                maxCards={instances?.maxNumber}
                resetOnChange={Number(router.query.instanceId)}
                headlineElement={'h2'}
                pending={instances.pending}
                cards={instances?.data?.map((instance) => (
                    <TeaserCard key={`more-instances-instance-${instance.id}`} instance={instance}/>
                ))}
                onLoadNewItems={(data) => {
                    fetchInstancesWithFilter(data.pageOrOffset, data.size);
                }}
                type={BasicCardVariants.BASIC_CARD_SMALL}
            />
        </div>
    );
};

export default MoreInstancesBox;
